export const CREATE_SESSION = 'CREATE_SESSION';
export const PERSONAL_DATA = 'PERSONAL_DATA';
export const CLOSE_SESSION = 'CLOSE_SESSION';